import { Autocomplete, Box, Input, Modal, TextField, Typography, ToggleButtonGroup, ToggleButton, RadioGroup, FormControlLabel, Radio, Checkbox } from '@mui/material';
import { TimePicker, KeyboardDatePicker } from "@material-ui/pickers";
import { createFilterOptions } from '@mui/material/Autocomplete';
import LoadingButton from '@mui/lab/LoadingButton';
import React, { useEffect, useState } from 'react';

import "../modal.scss"
import { SmartToyRounded } from '@mui/icons-material';
const filter = createFilterOptions();

const ScheduleBlockAddModal = (props) => {
	const [open, setOpen] = useState(props.open);
	const [isEdit, setIsEdit] = useState(false);

	const [schedule, setSchedule] = useState();
	const [name, setName] = useState();
	const [type, setType] = useState('Event');
	const [days, setDays] = useState([]);
	const [startTime, setStartTime] = useState();
	const [endTime, setEndTime] = useState();
	const [startTimeDisplay, setStartTimeDisplay] = useState();
	const [endTimeDisplay, setEndTimeDisplay] = useState();
	const [eventDate, setEventDate] = useState();
	const [endDate, setEndDate] = useState();
	const [isOccupied, setIsOccupied] = useState(true)
	const [isHoliday, setIsHoliday] = useState(false)

	const [highTempPref, setHighTempPref] = useState(74)
	const [lowTempPref, setLowTempPref] = useState(68)
	const [robotMode, setRobotMode] = useState()

	const [isSubmitting, setIsSubmitting] = useState(false);
	const [isDeleting, setIsDeleting] = useState(false);

	useEffect(() => {
		setOpen(props.open);
	}, [props.open])

	useEffect(() => {
		let block = props.event;
		if (!block) return;

		setIsEdit(true);

		let selectedSchedule = props.schedules.find(s => s.id == block.schedule_id)
		setSchedule(selectedSchedule);
		setName(block.name)
		setType(block.type)
		setDays(block.days)
		setEventDate(new Date(block.event_date))

		let [startHour, startMinutes] = block.start_time.split(":")
		let startTimeDate = new Date();
		startTimeDate.setHours(startHour)
		startTimeDate.setMinutes(startMinutes)
		setStartTime(block.start_time)
		setStartTimeDisplay(startTimeDate) 

		let [endHour, endMinutes] = block.end_time.split(":")
		let endTimeDate = new Date();
		endTimeDate.setHours(endHour)
		endTimeDate.setMinutes(endMinutes)
		setEndTime(block.end_time)
		setEndTimeDisplay(endTimeDate) 

		setEndDate(block.end_date)

		if (block.attributes.find(a => a === "Occupied")) 
			setIsOccupied(true);
		else setIsOccupied(false);

		if (block.attributes.find(a => a === "Holiday"))
			setIsHoliday(true)
		else setIsHoliday(false);

		let robot_mode = block.values.find(v => v.value_label === "robot_mode")
		if (robot_mode) setRobotMode(robot_mode.value);

		let low_temp = block.values.find(v => v.value_label === "heating_setpoint")
		if (low_temp) setLowTempPref(low_temp.value)
		else setLowTempPref(null)

		let high_temp = block.values.find(v => v.value_label === "cooling_setpoint")
		if (high_temp) setHighTempPref(high_temp.value)
		else setHighTempPref(null)
			
	}, [props.event])

	useEffect(() => {
		if (props.startHour) {
			let startTimeDate = new Date();
			startTimeDate.setHours(props.startHour)
			startTimeDate.setMinutes(0)
			setStartTime(props.startHour + ":00")
			console.log(props.startHour + ":00")
			setStartTimeDisplay(startTimeDate) 
	
			let endHour = parseInt(props.startHour) + 1
			console.log(endHour)
			let endTimeDate = new Date();
			endTimeDate.setHours(endHour)
			endTimeDate.setMinutes(0)
			setEndTime(endHour + ":00")
			setEndTimeDisplay(endTimeDate) 
		}
	}, [props.startHour])

	useEffect(() => {
		console.log(props.selectedSchedule)
		setSchedule(props.selectedSchedule)
	}, [props.selectedSchedule])

	const handleClose = () => props.closeCallback();

	const handleNameChange = (event) => setName(event.target.value);
	const handleTypeChange = (event) => setType(event.target.value)
	const handleEventDateChange = (event) => setEventDate(event.toJSDate());
	const handleEndDateChange = (event) => setEndDate(event.target.value);
	const handleOccupiedChange = (event) => setIsOccupied(event.target.value === "Occupied");
	const handleHolidayChange = (event) => setIsHoliday(event.target.checked);
	const handleHighTempChange = (event) => setHighTempPref(event.target.value);
	const handleLowTempChange = (event) => setLowTempPref(event.target.value);
	const handleRobotModeChange = (event) => setRobotMode(event.target.value);

	const handleStartTimeChange = (datetime) => {
		let startHour = datetime.hour < 10 ? "0" + datetime.hour : datetime.hour;
		let startMinutes = datetime.minute < 10 ? "0" + datetime.minute : datetime.minute;
		setStartTime(startHour + ":" + startMinutes)
		setStartTimeDisplay(datetime);
	}
	const handleEndTimeChange = (datetime) => {
		let endHour = datetime.hour < 10 ? "0" + datetime.hour : datetime.hour;
		let endMinutes = datetime.minute < 10 ? "0" + datetime.minute : datetime.minute;
		setEndTime(endHour + ":" + endMinutes)
		setEndTimeDisplay(datetime);
	}

	const handleDaysChange = (event) => {
		let dayChange = event.target.value;
		let newDays = Object.assign([], days)

		if (newDays.find(d => d === dayChange)) {
			newDays = newDays.filter(d => d !== dayChange)
		} else newDays.push(dayChange)

		setDays(newDays)
	}

	const formatDate = (date) => {
		if (!date) return null;
		const offset = date.getTimezoneOffset();
		date = new Date(date.getTime() - (offset*60*1000));
		return date.toISOString().split('T')[0];
	}

  	async function handleSubmit(event) {
		
		event.stopPropagation();
		setIsSubmitting(true);
		console.log("Submitting")
		if (schedule && !schedule.id) {
			props.addSchedule(schedule).then(response => {
				console.log(response)
				let addedSchedule = Object.assign({}, schedule)
				addedSchedule.id = response.id
				setSchedule(addedSchedule);
				submitBlock(addedSchedule);
			}).catch(error => {
				console.log("Got the error in the modal")
			})
		} else submitBlock();
	}

	function submitBlock(newSchedule) {
		let block = {
			schedule_id: schedule.id || (newSchedule && newSchedule.id),
			name: name,
			days: days,
			type: type,
			event_date: eventDate ? formatDate(eventDate) : formatDate(new Date()),
			start_time: startTime,
			end_time: endTime,
			startDate: props.event ? props.event.start_date : formatDate(new Date()),
			endDate: formatDate(endDate),
		}

		if (props.event) {
			block.id = props.event.id
		}

		let attributes = []
		if (isOccupied) attributes.push('Occupied')
		else attributes.push('Unoccupied')
		if (isHoliday) attributes.push('Holiday')
		block.attributes = attributes

		let values = []
		if (robotMode) {
			values.push({
				value_label: "robot_mode",
				value: robotMode
			})
		}

		if (lowTempPref) {
			values.push({
				value_label: "heating_setpoint",
				value: lowTempPref
			})
		}

		if (highTempPref) {
			values.push({
				value_label: "cooling_setpoint",
				value: highTempPref
			})
		}
		block.values = values

		if (isEdit) {
			props.editScheduleBlock(block).then(response => {
				console.log("Got the response")
				console.log(response)
				setIsSubmitting(false)
			}).catch(error => {
				console.log("Got the error in the modal")
			})
		} else {
			props.addNewScheduleBlock(block).then(response => {
				console.log("Got the response")
				setIsSubmitting(false)
			})
		}
	}

	function handleDelete() {
		setIsDeleting(true);
		props.deleteBlock(props.event).then(response => {
			setIsDeleting(false);
			setOpen(false)
		})
	}

	console.log("Drawing oage")
	

  return (
    	<Modal sx={{border: '0px'}} open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
			<Box
				sx={{
					position: 'absolute',
					display: 'flex',
					flexDirection: 'column',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: 350,
					bgcolor: 'background.paper',
					border: '1px solid #CCC',
					borderRadius: 3,
					boxShadow: 24,
					maxHeight: 700,
					overflowY: 'scroll',
					p: 4,
				}}
			>
          	<div className="modal-header">{ isEdit ? "Update Schedule Block" : "Add Schedule Block" }</div>
            <form>
				<Box flexDirection="column" display="flex">
					<div className="row-form-field">
						<Autocomplete
							freeSolo
							selectOnFocus
							clearOnBlur
							handleHomeEndKeys
							id="schedule"
							options={props.schedules || []}
							value={schedule || ''}
							required
							getOptionLabel={(option) => {
								// Value selected with enter, right from the input
								if (typeof option === 'string') {
								return option;
								}
								// Add "xxx" option created dynamically
								if (option.inputValue) {
								return option.name;
								}
								// Regular option
								return option.name;
							}}
							renderInput={(params) => <TextField {...params} required label="Add to schedule..." variant="outlined" size="small" />}
							renderOption={(props, option) => <li {...props}>{option.name}</li>}
							onChange={(event, newValue) => {
								console.log("Change value: " + newValue)
								if (typeof newValue === 'string') {
									console.log(newValue)
									setSchedule(newValue);
								} else if (newValue && newValue.inputValue) {
									// Create a new value from the user input
									setSchedule({
										name: newValue.inputValue,
									});
								} else {
									console.log("What is this case?")
									setSchedule(newValue);
								}
							}}
							onBlur={(event, value) => {
								console.log("Blurred value: " + value)
							}}
							filterOptions={(options, params) => {
								const filtered = filter(options, params);
						
								const { inputValue } = params;
								// Suggest the creation of a new value
								const isExisting = options.some((option) => inputValue === option.name);
								if (inputValue !== '' && !isExisting) {
									filtered.push({
										inputValue,
										name: `Add schedule "${inputValue}"`,
									});
								}
								return filtered;
							}}
						/>
					</div>
					<div className="row-form-field">
						<TextField id="name" label="Describe this schedule block" variant="outlined" size="small" value={name || ''} required fullWidth onChange={handleNameChange} />
					</div>
					<div className="line-separator" />
					<div className="modal-section-header">Time of Day</div>
					<div className="row-form-field multi-field">
						<TimePicker
							label="Start"
							value={startTimeDisplay}
							onChange={handleStartTimeChange}
							size="small"
							inputVariant="outlined"
							style={{width: 100}}
							/>
						<div style={{paddingLeft: 15, paddingRight: 15}}>-</div>
						<TimePicker
							label="End"
							value={endTimeDisplay}
							onChange={handleEndTimeChange}
							size="small"
							inputVariant="outlined"
							style={{width: 100}}
							/>
					</div>
					<div className="line-separator" />
					<div className="modal-section-header">Event Type</div>

					<div className="row-form-field">
						<ToggleButtonGroup
								value={type}
								exclusive
								size="small"
								onChange={handleTypeChange}
							>
							<ToggleButton value="Event">Once</ToggleButton>
							<ToggleButton value="Repeating">Repeating</ToggleButton>
						</ToggleButtonGroup>
					</div>
					{
						type === 'Event' ?
						<div className="row-form-field">
							<KeyboardDatePicker
								autoOk
								options={[]}
								variant="inline"
								inputVariant="outlined"
								label="Event Date"
								format="MM/dd/yyyy"
								size={"small"}
								value={eventDate}
								onChange={(date) => {handleEventDateChange(date)}}
							/>
						</div> : null
					}

					{/* Going to leave this out for now 	
					{
						type === "Event" ?   
							<div className="row-form-field">
								<FormControlLabel control={<Checkbox defaultChecked={isHoliday} onChange={handleHolidayChange} />} label="Is this a holiday?" /> 
							</div>
							: null
					} */}

					{
						type === 'Repeating' ?
						<div className="row-form-field">
							<ToggleButtonGroup
								value={days}
								size="small"
								onChange={handleDaysChange}
							>
								<ToggleButton value="Sunday">S</ToggleButton>
								<ToggleButton value="Monday">M</ToggleButton>
								<ToggleButton value="Tuesday">Tu</ToggleButton>
								<ToggleButton value="Wednesday">W</ToggleButton>
								<ToggleButton value="Thursday">Th</ToggleButton>
								<ToggleButton value="Friday">F</ToggleButton>
								<ToggleButton value="Saturday">S</ToggleButton>
							</ToggleButtonGroup>
						</div> : null
					}

					{ type === 'Repeating' ? <div className="modal-section-header">Ends</div> : null }
					{
						type === 'Repeating' ?
						<div className="row-form-field">
							<RadioGroup defaultValue="never" name="end-date-group">
                       			<FormControlLabel value="never" control={<Radio size="small"/>} label={<Typography sx={{ fontSize: 12 }}>NEVER</Typography>}  onClick={() => { setEndDate(null) }}/>
                        		<FormControlLabel value="date" 
									control={<Radio size="small"/>} 
									label={
										<div className="option-aligned">
											<Typography sx={{ fontSize: 12, paddingRight: 5, width: 20 }}>
												ON 
											</Typography>
											<KeyboardDatePicker
													autoOk
													variant="inline"
													inputVariant="outlined"
													label="End Date"
													format="MM/dd/yyyy"
													size={"small"}
													value={endDate}
													onChange={(date) => {handleEndDateChange(date)}}
												/>
										</div>
									}
								/>  
							</RadioGroup>
						</div> : null
					}

					<div className="line-separator" />
					<div className="modal-section-header">Mode</div>

					<div className="row-form-field">
						<ToggleButtonGroup
							value={isOccupied? "Occupied" : "Unoccupied"}
							size="small"
							exclusive
							onChange={handleOccupiedChange}
						>
							<ToggleButton value="Occupied">Occupied</ToggleButton>
							<ToggleButton value="Unoccupied">Unoccupied</ToggleButton>
						</ToggleButtonGroup>
					</div> 

					<div className="row-form-field">
						<RadioGroup defaultValue="comfort" name="mode-group" value={robotMode}>
							<FormControlLabel value="comfort" control={<Radio size="small"/>} label={<div className="radio-label">Maximum Comfort</div>}  onClick={() => { handleRobotModeChange(null) }}/>
							<FormControlLabel value="Demand Reduction" control={<Radio size="small"/>} label={<div className="radio-label">Demand Reduction Mode<SmartToyRounded /></div>}  onClick={handleRobotModeChange}/>
							<FormControlLabel value="Energy Optimization" control={<Radio size="small"/>} label={<div className="radio-label">Energy Optimization Mode<SmartToyRounded /></div>}  onClick={handleRobotModeChange}/>
						</RadioGroup>
					</div>

					<div className="line-separator" />

					<div className="modal-section-header">Temperature Preferences</div>

					<div className="row-form-field multi-field">
						<TextField id="name" label="Low" variant="outlined" size="small" value={lowTempPref} fullWidth onChange={handleLowTempChange} required />
						<TextField id="name" label="High" variant="outlined" size="small" value={highTempPref} fullWidth onChange={handleHighTempChange} required />
					</div>

					{
						props.isEditable ?

						<div className="row-button-container">
							{
								isEdit ? 
								<LoadingButton 
									variant="contained" 
									loading={isDeleting} 
									onClick={handleDelete} 
									sx={{position: "absolute", left: 0, backgroundColor: "#003e51"}}>
										Delete
								</LoadingButton> 
								: null

							}
							<LoadingButton 
								variant="contained" 
								loading={isSubmitting} 
								type="submit" 
								onClick={handleSubmit}
								sx={{position: "absolute", right: 0, backgroundColor: "#003e51"}}>
									{ isEdit ? "Update" :  "Add Schedule Block" }
							</LoadingButton>
						</div> 
						: 
						<div className="row-button-container">

							<LoadingButton 
								variant="contained" 
								type="submit" 
								onClick={handleClose} 
								sx={{position: "absolute", right: 0, backgroundColor: "#003e51"}}>
									OK
							</LoadingButton>
						</div>
					}


                	
              	</Box>
            </form>
        </Box>
    </Modal>
  )
};

export default ScheduleBlockAddModal;
